var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReasonForChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#42A460",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4757 20.4356C26.3133 20.4356 23.7159 22.9286 23.7159 26.0118C23.7138 26.1745 23.777 26.3311 23.8913 26.4466C24.0056 26.5624 24.1613 26.6276 24.324 26.6276C24.4866 26.6276 24.6423 26.5624 24.7566 26.4466C24.871 26.3311 24.9339 26.1745 24.932 26.0118C24.932 23.6101 26.9476 21.6516 29.4758 21.6516C30.7373 21.6516 32.0059 22.1655 32.8759 22.9615C33.7459 23.7575 34.213 24.784 34.0248 25.9119V25.9126C33.6187 28.3659 32.5153 28.7755 31.2502 29.5521C30.6177 29.9405 29.933 30.4092 29.4675 31.2222C29.0019 32.0352 28.7873 33.1349 28.9091 34.7093C28.9194 34.8715 28.9945 35.0228 29.1173 35.1292C29.2401 35.2359 29.4005 35.2887 29.5627 35.2762C29.7248 35.2637 29.8752 35.1867 29.9801 35.0626C30.0851 34.9386 30.136 34.7774 30.1214 34.6155C30.0115 33.1917 30.2105 32.372 30.5227 31.8265C30.8351 31.281 31.2928 30.9529 31.8862 30.5887C33.0729 29.8603 34.7555 28.9428 35.2244 26.112V26.1113C35.4872 24.5334 34.8023 23.0758 33.6966 22.0643C32.5908 21.0526 31.0595 20.4354 29.4755 20.4354L29.4757 20.4356Z",
    fill: "#42A460",
    stroke: "#42A460",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4996 36.3624C28.837 36.3624 28.2861 36.9175 28.2861 37.5786C28.2861 38.2395 28.8333 38.7947 29.4996 38.7947C30.1658 38.7947 30.713 38.2433 30.713 37.5786C30.713 36.9139 30.162 36.3624 29.4996 36.3624Z",
    fill: "#42A460",
    stroke: "#42A460",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4998 16.1302C22.1171 16.1302 16.1211 22.1549 16.1211 29.5664C16.1211 36.9779 22.1171 43 29.4998 43C36.8825 43 42.8785 36.9785 42.8785 29.5664C42.8785 22.1544 36.8825 16.1302 29.4998 16.1302ZM29.4998 17.3463C36.2223 17.3463 41.6622 22.8091 41.6622 29.5669C41.6622 36.3246 36.2223 41.7842 29.4998 41.7842C22.7773 41.7842 17.3373 36.3246 17.3373 29.5669C17.3373 22.8091 22.7773 17.3463 29.4998 17.3463Z",
    fill: "#42A460",
    stroke: "#42A460",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonForChange);
export default __webpack_public_path__ + "static/media/reason-for-change.c44951183709f2834876033f91214b66.svg";
export { ForwardRef as ReactComponent };